export default "__VITE_ASSET__PKf3Q0s0__"